import { Pipe, PipeTransform } from '@angular/core';
// import { first } from 'rxjs/operators';

@Pipe({ name: 'trimLower' })
export class TrimLower implements PipeTransform {
  transform(str, args): any {

    if (str && typeof str === 'string') {
        return str.toString().toLowerCase().trim().replace(/ +/g, '');
      } else {
        return str;
      }
    }
}
